import createIcon from '../../createIcon';

/**
 * @component @name BrowserUpdated
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTNWMTZDMjIgMTcuMSAyMS4xIDE4IDIwIDE4SDE3TDE4IDE5VjIxSDZWMTlMNyAxOEg0QzIuOSAxOCAyIDE3LjEgMiAxNlY1QzIgMy45IDIuOSAzIDQgM0gxMlY1SDRWMTZIMjBWMTNIMjJaTTE1IDE1TDEwIDEwSDE0VjNIMTZWMTBIMjBMMTUgMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrowserUpdated = createIcon('BrowserUpdated', [
  [
    'path',
    {
      d: 'M22 13V16C22 17.1 21.1 18 20 18H17L18 19V21H6V19L7 18H4C2.9 18 2 17.1 2 16V5C2 3.9 2.9 3 4 3H12V5H4V16H20V13H22ZM15 15L10 10H14V3H16V10H20L15 15Z',
      key: 'fs3x90',
    },
  ],
]);

export default BrowserUpdated;
